import { join } from 'node:path';
import { readFile } from 'node:fs/promises';
import { globby } from 'globby';
import { getAppBackendBuildFolder } from '@wix/cli-app-definitions';
import { normalizeGlobbyPattern } from '../dev-center/components/path.js';

const backendPattern = normalizeGlobbyPattern(join('**', '*.mjs'));

export async function getBackendDeploymentFiles(projectFolder: string) {
  const backendFolder = getAppBackendBuildFolder(projectFolder);
  const backendFilePaths = await globby(backendPattern, { cwd: backendFolder });

  return Promise.all(
    backendFilePaths.map(async (filePath) => {
      return {
        filePath: `./${filePath}`,
        content: await readFile(join(backendFolder, filePath), 'utf-8'),
      };
    })
  );
}
